export default __webpack_public_path__ + "static/media/php.bf6243b5.svg";